/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from "shared/Components/button";
import Dropdown from "shared/Components/dropdown";
import { externalLinkWhite } from "helper/icons";
import Loader from "shared/Components/loader";
import { globalVariables } from "helper/globalVariables";

export const EditSitResultCard = ({
  loadingStatus,
  loadingRowId,
  id,
  DogName,
  ownerName,
  breed,
  anise,
  birch,
  clove,
  onDetail,
  selectDropdown,
}) => {
  const DropdownList = ["Passed", "Failed"]

  return (
    <div class="bg-white w-80 mt-10">

      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">{globalVariables.dogName}</h2>
        <h2 class="text-md">{DogName}</h2>
      </div>
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">{globalVariables.breed}</h2>
        <h2 class="text-md">{breed}</h2>
      </div>
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">{globalVariables.ownerName}</h2>
        <h2 class="text-md">{ownerName}</h2>
      </div>
      <div className="mt-4">
        <h2 className="text-xs text-gray-600 mb-2">{globalVariables.anise}</h2>
        <h2 className="text-md inline-block">
          {loadingRowId === id && loadingStatus === "anise" ? (
            <Loader />
          ) : (
            <Dropdown
              dropdownOptions={DropdownList}
              value={id}
              placeholder="Passed"
              width="w-[125px]"
              showIconRight
              defaultOption={anise === null ? "Select" : anise}
              onChange={(select) => selectDropdown(id, select, 'anise')}
            />
          )}

        </h2>
      </div>

      <div className="mt-4">
        <h2 className="text-xs text-gray-600 mb-2">Clove</h2>
        <h2 className="text-md inline-block">

          {loadingRowId === id && loadingStatus === "clove" ? (
            <Loader />
          ) : (
            <Dropdown
              dropdownOptions={DropdownList}
              value={id}
              defaultOption={clove === null ? "Select" : clove}
              placeholder="Passed"
              width="w-[125px]"
              showIconRight
              isFaded={true}
              onChange={(select) => selectDropdown(id, select, "clove")}
            />
          )}
        </h2>
      </div>
      <div className="mt-4">
        <h2 className="text-xs text-gray-600 mb-2">Birch</h2>
        <h2 className="text-md inline-block">
          {loadingRowId === id && loadingStatus === "birch" ? (
            <Loader />
          ) : (
            <Dropdown
              dropdownOptions={DropdownList}
              value={id}
              placeholder="Passed"
              width={"w-[125px]"}
              showIconRight
              defaultOption={birch === null ? "Select" : birch}
              onChange={(select) => selectDropdown(id, select, "birch")}
            />
          )}
        </h2>
      </div>
      <div className="mt-5 pt-5 border-t">
        <Button
          label="View Dog History"
          width="w-[100%] max-[380px]:w-[90%]"
          icon={externalLinkWhite}
          prefix={false}
          onClick={() => onDetail(id)}
        />
      </div>
    </div>
  );
};
